import request from './request'

export const commonQuestionApi = {
  listCommonQuestion (params) {
    return request.get('/questions', { params: params })
  },
  saveCommonQuestion (data) {
    return request.post('/question', data)
  },
  getCommonQuestion (id) {
    return request.get('/questions/' + id)
  },
  deleteCommonQuestion (id) {
    return request.delete('/questions/' + id)
  },
  updateCommonQuestion (id, data) {
    return request.put('/questions/' + id, data)
  },
}

export default commonQuestionApi
